import { useEffect, useRef } from 'react';
import { isNil } from 'lodash';
import { translateBackend } from 'assets/i18n/config';
import { Box, Switch } from '../..';
import InfoDialog from '../../2-component/infoDialog/infoDialog';

const checkDisabledIfHierarchy = (x: any, allOptions: any): boolean | undefined => {
  if (isNil(x.disabledIf)) return undefined;
  const optionsMap = new Map(allOptions.map((opt: any) => [opt.key, opt.value]));

  return Object.entries(x.disabledIf).some(([key, value]) => optionsMap.get(key) === value);
};

export const BooleanEdit = ({
  option, options, setOptions, i,
}: {
  option: any, options: any, setOptions: (x: any) => void, i: number
}) => {
  const wasDisabledRef = useRef(false);
  const isDisabled = checkDisabledIfHierarchy(option, options);
  const checked = option.value?.enabled ?? option.value;

  const onChange = (e: any) => {
    const newOptions = [...options];
    if (option.value && typeof option.value === 'object') {
      newOptions[i].value.enabled = e;
    } else {
      newOptions[i].value = e;
    }
    setOptions(newOptions);
  };

  useEffect(() => {
    if (isDisabled) {
      wasDisabledRef.current = checked;
      onChange(false);
    } else if (option.disabledIf && wasDisabledRef.current) {
      onChange(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDisabled]);

  return (
    <Box sx={{ mb: 2 }} display='flex'>
      <Switch label={translateBackend(option.label)} disabled={isDisabled} checked={checked} onChange={onChange} />
      {option.info && <InfoDialog information={translateBackend(option.info)} center />}
    </Box>
  );
};
